import { useContext } from 'react'

import { ChatContext } from './chatContext'

export const useChatContext = () => {
    const ctx = useContext(ChatContext)
    return ctx
}
